import { FaExternalLinkAlt, FaCarAlt } from 'react-icons/fa';
import FilledImage from 'src/components/molecules/FilledImage';

const StaticMap = ({ event, signedStaticMapUrl }) => {
  return (
    <>
      <div className="relative aspect-video h-[200px]">
        <a href={event.externalMapUrl} target="_blank" rel="noreferrer">
          <FilledImage
            url={signedStaticMapUrl}
            alt={`Map of ${event.venueName}`}
            className="rounded object-cover"
          />
        </a>
      </div>
      <div className="text-right text-sm mt-1 font-semibold1">
        <a
          className="inline-block focus:outline-none mr-4"
          href={event.externalMapUrl}
          target="_blank"
          rel="noreferrer"
        >
          <FaExternalLinkAlt className="inline-block text-theme-alt -mt-1" /> View on Google
          Maps
        </a>
        <a
          className="inline-block focus:outline-none"
          href={`https://www.google.com/maps/dir/?api=1&destination=${`${event.latitude},${event.longitude}`}`}
          target="_blank"
          rel="noreferrer"
        >
          <FaCarAlt className="inline-block text-theme-alt -mt-0.5" /> Get Directions
        </a>
      </div>
    </>
  );
};

export default StaticMap;
